import { ChevronRight } from 'lucide-react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import type { NavItem } from './navigation'

interface HeaderBreadcrumbProps {
  items: NavItem[]
  current: NavItem | undefined
}

/** Trilha da barra superior: seção › grupo (se houver) › página atual do menu. */
export function HeaderBreadcrumb({ items, current }: HeaderBreadcrumbProps) {
  const { t } = useTranslation()

  if (!current) return null

  const parent = items.find((item) => item.children?.some((child) => child.to === current.to))
  const group = current.group ?? parent?.group
  // Grupo, item pai e página podem ter o mesmo nome (ex.: "Chamados"); repetidos em sequência viram um só.
  const trail = [group ? t(group) : null, parent ? t(parent.labelKey) : null, t(current.labelKey)].filter(
    (label, index, labels): label is string => label !== null && label !== labels[index - 1],
  )

  return (
    <nav aria-label={t('nav.breadcrumb')} className="hidden min-w-0 items-center gap-1.5 text-sm lg:flex">
      {trail.map((label, index) => {
        const last = index === trail.length - 1

        return (
          <Fragment key={`${index}-${label}`}>
            {index > 0 ? (
              <ChevronRight className="size-3.5 shrink-0 text-muted-foreground" aria-hidden />
            ) : null}
            <span
              aria-current={last ? 'page' : undefined}
              className={last ? 'truncate font-bold text-foreground' : 'truncate text-muted-foreground'}
            >
              {label}
            </span>
          </Fragment>
        )
      })}
    </nav>
  )
}
